import { lazy } from "react";
import RenderSubSection from "./RenderSubSections";

const OrderSetting = lazy(() => import("pages/Setting"));
const ProductionOperation = lazy(() => import("pages/Setting/Production"));
const VendorSignature = lazy(() => import("pages/Setting/VendorSignature"));
const DriversBarcode = lazy(() => import("pages/Setting/DriversBarcode"));

const setting = {
    name: "تنظیمات سفارشات",
    path: "/orders-setting",
    group: "orders-setting",
    exact: true,
    component: () => <OrderSetting />,
};

const erpSetting = {
    name: "عملیات تولید",
    path: "/production-operation",
    group: "production-operation",
    exact: true,
    component: () => <ProductionOperation />,
};

const vendorSignature = {
    name: "بارگذاری مهر و امضا",
    path: "/add-signature",
    group: "add-signature",
    exact: true,
    component: () => <VendorSignature />,
};

const driversBarcode = {
    name: "بارکد رانندگان",
    path: "/add-barcode",
    group: "add-barcode",
    exact: true,
    component: () => <DriversBarcode />,
};
const subSections = {
    main: {
        list: { ...setting },
        view: { ...erpSetting },
    },
    signature: {
        list: { ...vendorSignature },
    },
    barcode: {
        list: { ...driversBarcode },
    },
};

const settingSection = {
    title: "تنظیمات",
    key: "setting",
    SubRoutes: (keywords: any) => RenderSubSection(keywords, subSections),
};

export default settingSection;
